/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import LocationItem from "./LocationItem";
import LocationItemSkeleton from "../../skeleton/LocationItemSkeleton";
import { useLocations } from "../../../lib/react-query/useLocations";
import EmptyStep from "../steps/EmptyStep";

const LocationsList = () => {
  const { data: locations, isLoading } = useLocations();

  if (isLoading) {
    return (
      <>
        <LocationItemSkeleton />
        <LocationItemSkeleton />
      </>
    );
  }

  if (!locations.length) {
    return <EmptyStep message="No locations available" />;
  }

  return locations.map((location) => <LocationItem key={location.id} location={location} />);
};

export default LocationsList;
